export default __webpack_public_path__ + "static/media/microwave.5a54cf49.png";